module.exports = __webpack_public_path__ + "img/email_follow_up.3e500db0.png";